import {attended} from 'constants/url';
import useLoad from './useLoad';

function useLoadAttended(isCollabReadOnly: any, id: any) {
  return useLoad(attended, ['iD_Course', 'iD_Instance', 'employee_Nr'], {
    additional: isCollabReadOnly,
    detail: id,
  });
}

export default useLoadAttended;
